import React from 'react'
import { Link } from 'react-scroll'

import PricingPlan from './Components/PricingPlan'

const pricingData = [{
  id: 1,
  attributes: {
    isActive: false,
    title: 'Starter',
    features: [{
      title: 'Storage & management of 3D models',
      isPresent: true,
    }, {
      title: '3D viewer for desktop devices',
      isPresent: true,
    }, {
      title: 'Mobile AR experiences (iOS & Android)',
      isPresent: true,
    }, {
      title: 'Customer support',
      isPresent: true,
    }, {
      title: 'White Labelling',
      isPresent: false,
    }, {
      title: 'Dedicated Account Manager',
      isPresent: false,
    }],
    limitations: [{
      title: 'Model limit',
      value: 10,
    }, {
      title: 'Model views limit',
      value: 10000,
    },
    ],
    monthlyPrice: 19,
    yearlyPrice: 16,
    additionalViews: {
      count: 10000,
      price: 30,
    },
  },
}, {
  id: 2,
  attributes: {
    isActive: false,
    title: 'Basic',
    features: [{
      title: 'Storage & management of 3D models',
      isPresent: true,
    }, {
      title: '3D viewer for desktop devices',
      isPresent: true,
    }, {
      title: 'Mobile AR experiences (iOS & Android)',
      isPresent: true,
    }, {
      title: 'Customer support',
      isPresent: true,
    }, {
      title: 'White Labelling',
      isPresent: false,
    }, {
      title: 'Dedicated Account Manager',
      isPresent: false,
    }],
    limitations: [{
      title: 'Model limit',
      value: 100,
    }, {
      title: 'Model views limit',
      value: 50000,
    },
    ],
    monthlyPrice: 89,
    yearlyPrice: 76,
    additionalViews: {
      count: 25000,
      price: 64,
    },
  },
}, {
  id: 3,
  attributes: {
    isActive: false,
    title: 'Pro',
    features: [{
      title: 'Storage & management of 3D models',
      isPresent: true,
    }, {
      title: '3D viewer for desktop devices',
      isPresent: true,
    }, {
      title: 'Mobile AR experiences (iOS & Android)',
      isPresent: true,
    }, {
      title: 'Customer support',
      isPresent: true,
    }, {
      title: 'White Labelling',
      isPresent: true,
    }, {
      title: 'Dedicated Account Manager',
      isPresent: false,
    }],
    limitations: [{
      title: 'Model limit',
      value: 300,
    }, {
      title: 'Model views limit',
      value: 120000,
    },
    ],
    monthlyPrice: 240,
    yearlyPrice: 204,
    additionalViews: {
      count: 50000,
      price: 113,
    },
  },
}, {
  id: 4,
  attributes: {
    isActive: false,
    title: 'Enterprise',
    features: [{
      title: 'Storage & management of 3D models',
      isPresent: true,
    }, {
      title: '3D viewer for desktop devices',
      isPresent: true,
    }, {
      title: 'Mobile AR experiences (iOS & Android)',
      isPresent: true,
    }, {
      title: 'Customer support',
      isPresent: true,
    }, {
      title: 'White Labelling',
      isPresent: true,
    }, {
      title: 'Dedicated Account Manager',
      isPresent: true,
    }],
    limitations: [{
      title: 'Models',
      value: 'Unlimited',
    }, {
      title: 'Model views limit',
      value: 'Custom',
    },
    ],
    monthlyPrice: null,
    yearlyPrice: 'Custom',
    additionalViews: {
      count: null,
      price: null,
    },
  },
}]

function PricingTable() {
  return (
    pricingData.length > 0 && (
      <section className="info-section info-section--white">
        <div className="container-fixed">
          <div className="row align-items-center">
            <div className="col-12 col-xl-10 offset-xl-1">
              <h2 className="heading-40 info-section__heading">
                <strong>
                  Plans
                </strong> & Pricing
              </h2>
              <div className="pricing-table">
                <div className="row">
                  {pricingData.map((plan) => <PricingPlan key={`pricing-plan-${plan.id}`} {...plan.attributes} />)}
                  <div className="col-12 u-text-center">
                    <Link to="lets-talk" offset={-60} smooth>
                      <span className="btn btn-primary pricing-table__cta">Contact for more details</span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  )
}

export default PricingTable
